import Vue from 'vue';
import { mapActions, mapMutations, mapState } from 'vuex';
export default Vue.extend({
    name: 'News',
    inject: ['checkUrl', 'mapUrl'],
    props: ['filterClassNow', 'filterPlatformNow', 'filterPlatforms'],
    data() {
        return {
            downloadIconText: {
                introduce: 'mdi-file-document-outline',
                source: 'mdi-file-image-outline',
                document: 'mdi-file-code-outline'
            }
        };
    },
    computed: {
        ...mapState('common', ['lang']),
        ...mapState('auth', ['isLogin', 'loginUser']),
        ...mapState('news', ['newsList', 'sourceTargetKey']),
        filteredList() {
            let arr = [];
            const currClass = parseInt(this.filterClassNow);
            for (const i in this.newsList) {
                const curr = this.newsList[i];
                if ((currClass === 0 || currClass === curr.class_id) &&
                    (this.filterPlatformNow === 'all' ||
                        curr.platforms.includes(this.filterPlatformNow))) {
                    arr.push(curr);
                }
            }
            arr = arr.sort(function (a, b) {
                return a.date_start > b.date_start ? -1 : 1;
            });
            return arr;
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapMutations('common', ['ChangeDialog']),
        ...mapActions('message', ['setSnackbar']),
        ...mapActions('news', ['getNews', 'setCurrNews']),
        init() {
            this.getNews();
        },
        getDetail(item) {
            const key = this.lang === 'cn' ? 'detail' : 'detail_en';
            return item[key] !== 'undefined' ? item[key] : item.detail;
        },
        downloadLink(item, key) {
            switch (key) {
                case 'source':
                    if (this.isLogin) {
                        this.setCurrNews(item);
                        this.ChangeDialog('Source');
                    }
                    else {
                        this.setSnackbar({
                            show: true,
                            text: 'LOGINERROR_1',
                            timeout: 1200
                        });
                    }
                    break;
                case 'document':
                    this.$router.push(item[key]).catch(err => {
                        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected')) {
                            console.error(err);
                        }
                    });
                    break;
                case 'introduce':
                    {
                        const routeUrl = this.$router.resolve({
                            path: '/download',
                            query: { fileName: item.download[key], fileClass: key }
                        });
                        window.open(routeUrl.href, '_blank', '');
                    }
                    break;
            }
        },
        checkBtn(item, key) {
            const url = this.mapUrl(item.download[key], key);
            const res = !url ? false : url;
            switch (key) {
                case 'document': {
                    if (item[key]) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                case 'sorce': {
                    const urlB = this.mapUrl(item.download.psd, 'psd');
                    const resB = !urlB ? false : urlB;
                    if (res || resB) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                default: {
                    if (res) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
        }
    }
});
